var styles = {
  "LayoutGroup": "Online-Store-UI-LayoutGroup_1txj6",
  "grow": "Online-Store-UI-LayoutGroup--grow_1kvwd",
  "shrink": "Online-Store-UI-LayoutGroup--shrink_mtbh8",
  "center": "Online-Store-UI-LayoutGroup--center_br81y",
  "distributeSpace": "Online-Store-UI-LayoutGroup--distributeSpace_1ctiw",
  "alignRight": "Online-Store-UI-LayoutGroup--alignRight_9yh95",
  "paddedBoth": "Online-Store-UI-LayoutGroup--paddedBoth_1emzu",
  "usesBottomSheet": "Online-Store-UI-LayoutGroup--usesBottomSheet_16ooh",
  "paddedLeft": "Online-Store-UI-LayoutGroup--paddedLeft_1ga9m",
  "paddedRight": "Online-Store-UI-LayoutGroup--paddedRight_175mb",
  "spacingNone": "Online-Store-UI-LayoutGroup--spacingNone_162ba",
  "spacingBase": "Online-Store-UI-LayoutGroup--spacingBase_l0815",
  "spacingTight": "Online-Store-UI-LayoutGroup--spacingTight_1lm6d",
  "spacingLoose": "Online-Store-UI-LayoutGroup--spacingLoose_1l5hi",
  "spacingBase-tight": "Online-Store-UI-LayoutGroup__spacingBase--tight_fktb2",
  "spacingExtra-tight": "Online-Store-UI-LayoutGroup__spacingExtra--tight_1ywc4",
  "alignBaseline": "Online-Store-UI-LayoutGroup--alignBaseline_sblep"
};

export { styles as default };
